var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTrashStriped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13766 2.14718C5.70215 2.14718 5.34707 2.50122 5.34707 2.94251C5.34707 3.33238 5.03103 3.64843 4.64119 3.64843C4.25134 3.64843 3.9353 3.33238 3.9353 2.94251C3.9353 1.72726 4.91669 0.735352 6.13766 0.735352H10.3918C11.6099 0.735352 12.5988 1.72437 12.5988 2.94251C12.5988 3.33238 12.2828 3.64843 11.8929 3.64843C11.5031 3.64843 11.1871 3.33238 11.1871 2.94251C11.1871 2.50411 10.8302 2.14718 10.3918 2.14718H6.13766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55417 4.97361C2.94244 4.93854 3.28562 5.22488 3.32069 5.61316L4.11141 14.368C4.13568 14.6431 4.36648 14.8536 4.6412 14.8536H11.8883C12.163 14.8536 12.3938 14.6431 12.418 14.368L12.4182 14.3665L13.2088 5.61316C13.2438 5.22488 13.587 4.93854 13.9753 4.97361C14.3636 5.00868 14.6499 5.35188 14.6148 5.74017L13.8244 14.4921C13.8243 14.4925 13.8243 14.4929 13.8242 14.4933C13.735 15.4977 12.8931 16.2654 11.8883 16.2654H4.6412C3.63619 16.2654 2.79423 15.4974 2.70518 14.4929C2.70516 14.4926 2.70513 14.4923 2.70511 14.4921L1.91465 5.74017C1.87958 5.35188 2.1659 5.00868 2.55417 4.97361Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61763 5.44141C7.00747 5.44141 7.32351 5.75746 7.32351 6.14732V12.7359C7.32351 13.1257 7.00747 13.4418 6.61763 13.4418C6.22778 13.4418 5.91174 13.1257 5.91174 12.7359V6.14732C5.91174 5.75746 6.22778 5.44141 6.61763 5.44141Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91182 5.44141C10.3017 5.44141 10.6177 5.75746 10.6177 6.14732V12.7359C10.6177 13.1257 10.3017 13.4418 9.91182 13.4418C9.52197 13.4418 9.20593 13.1257 9.20593 12.7359V6.14732C9.20593 5.75746 9.52197 5.44141 9.91182 5.44141Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44116 3.41307C1.44116 3.0232 1.7572 2.70715 2.14704 2.70715H14.3823C14.7722 2.70715 15.0882 3.0232 15.0882 3.41307C15.0882 3.80294 14.7722 4.11898 14.3823 4.11898H2.14704C1.7572 4.11898 1.44116 3.80294 1.44116 3.41307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrashStriped);
export default __webpack_public_path__ + "static/media/ic_trash_striped.5820b953d206fc1a0aa44df60a3f39e1.svg";
export { ForwardRef as ReactComponent };